<gh-sub-nav-options class="ml-11px mt-10px mb-10px d-block" [options]="options"></gh-sub-nav-options>
<div class="borderline"></div>
<gh-nav-items-list
  *ngIf="favorites && favorites.items.length"
  [collection]="favorites"
  [config]="{
    sectionLabelKey: 'favorites',
    visibleItemsCount: visibleItemsCount,
    itemsType: itemsType,
    itemsGroupType: 'favorites'
  }"></gh-nav-items-list>
<gh-nav-items-list
  *ngIf="recent && recent.items.length"
  [collection]="recent"
  [config]="{
    sectionLabelKey: 'recent',
    visibleItemsCount: visibleItemsCount,
    itemsType: itemsType,
    itemsGroupType: 'recent'
  }"></gh-nav-items-list>
